import { IHistoricalTeam } from 'src/app/shared/models/team/ihistoricalTeam';
import { Workspace } from '../workspace/workspace';
import { SeatTermsStatus } from 'src/app/people/models/seatTermsStatus';

export class HistoricalTeam implements IHistoricalTeam {
  public id: string;
  public name: string;
  public positionTitle: string;
  public startDate: Date;
  public endDate: Date;
  public workspaceId: string;
  public workspace: Workspace;
  public seatTermsStatus: SeatTermsStatus;

  constructor(historicalTeamWrite: any = undefined) {
    if (historicalTeamWrite) this.setProperties(historicalTeamWrite);
  }

  private setProperties(historicalTeamWrite: any) {
    this.id = historicalTeamWrite.id;
    this.name = historicalTeamWrite.name;
    this.positionTitle = historicalTeamWrite.positionTitle;
    this.startDate = historicalTeamWrite.startDate;
    this.endDate = historicalTeamWrite.endDate;
    this.workspaceId = historicalTeamWrite.workspaceId;
    this.workspace = historicalTeamWrite.workspace;
    this.seatTermsStatus = historicalTeamWrite.seatTermsStatus;
  }

  isThisHistoricalTeam(historicalTeamWrite: HistoricalTeam): boolean {
    return this.id !== historicalTeamWrite.id;
  }
}
